import { Card, PageHeader } from '@allurion/ui';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { TrackedButton } from 'src/analytics/TrackedUI';
import { useAppNavigate } from 'src/hooks/useAppNavigate';
import { InvitePatientApiPayload } from 'src/pages/InvitePatientPage/InvitePatient.types';

import { Container, InnerContainer } from '../shared-page-elements';

import translations from './InvitePatient.translations';

import styles from './InvitePatientSuccess.module.scss';

type Props = {
  data: InvitePatientApiPayload;
  reset: () => void;
};

export function InvitePatientSuccess({ data, reset }: Props) {
  const intl = useIntl();
  const { toClinicPage, toPatientPage } = useAppNavigate();
  const { clinicId } = useParams();

  const { firstName, lastName, email, patientId } = data;
  const name = `${firstName} ${lastName}`;

  return (
    <>
      <PageHeader title={intl.formatMessage(translations.header)} />
      <Container>
        <InnerContainer>
          <Card>
            <h2 className={styles.title}>{intl.formatMessage(translations.added, { name })}</h2>
            <div className={styles.description}>
              <p className={styles.invitation}>
                {intl.formatMessage(translations.invitation, { email })}
              </p>
              <p className={styles.instructions}>
                {intl.formatMessage(translations.instructions, { name })}
              </p>
              <p className={styles.expiration}>{intl.formatMessage(translations.expiration)}</p>
            </div>
            <div className={styles.actions}>
              <TrackedButton
                label={intl.formatMessage(translations.backToClinicBtn)}
                onClick={backToClinic}
                trackLabel="confirm-invite-patient-success"
                variant="outlined"
              />
              {patientId && (
                <TrackedButton
                  label={intl.formatMessage(translations.viewPatientBtn)}
                  onClick={viewPatient}
                  trackLabel="confirm-invite-patient-success"
                  variant="secondary"
                />
              )}
              <TrackedButton
                label={intl.formatMessage(translations.inviteAnotherPatientBtn)}
                onClick={inviteAnotherPatient}
                trackLabel="confirm-invite-patient-success"
              />
            </div>
          </Card>
        </InnerContainer>
      </Container>
    </>
  );

  function backToClinic() {
    toClinicPage(clinicId);
  }

  function viewPatient() {
    toPatientPage(clinicId!, patientId!);
  }

  function inviteAnotherPatient() {
    reset();
  }
}
